/*!
 * @Author: leo
 * @Date: 2019-12-27 18:12:00
 * @Last Modified by: Robin
 * @Last Modified time: 2024-07-23 22:36:44
 * @Introduction: 总路由
 */

import Vue from 'vue'
import Router, { RouteConfig } from 'vue-router'
import EnterpriseRoutes from './modules/enterprise'
import PersonRoutes from './modules/person'
import ReporterRoutes from './modules/reporter'
import MediaRoutes from './modules/media'
import NewsRoutes from './modules/news'
import ClueRoutes from './modules/clue'
import EventRoutes from './modules/event'
import SettingRoutes from './modules/setting'
import OthersRoutes from './modules/other'
import SecurityRoutes from './modules/security'
import WinpressRoutes from './modules/winpress'
import UtilsRoutes from './modules/utils'
import PreviewRoutes from './modules/preview'
import ReleaseRoutes from './modules/release'
import LogRoutes from './modules/log'
import ReportRoutes from './modules/report'
import OnlineRoutes from './modules/online'
import ContentRoutes from './modules/content'

const Dashboard = () => import('@/views/dashboard/index.vue')
const Login = () => import('@/views/login/index.vue')
const OIDCCallback = () => import('@/views/callback/index.vue')
const Profile = () => import('@/views/profile/index.vue')
const BugList = () => import('@/views/bug/list.vue')

Vue.use(Router)

/* Layout */
import Layout from '@/layout/index.vue'
export { Layout }

/** 注意: 默认展开配置在 sideBar 文件中配置 */
// 普通用户路由
export const constantRoutes: RouteConfig[] = [
    {
        path: '/login',
        component: Login,
        meta: {
            title: '登录',
            hidden: true
        }
    },
    {
        path: '/callback',
        component: OIDCCallback,
        meta: {
            title: 'OIDC 回调',
            hidden: true
        }
    },
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        children: [
            {
                path: 'dashboard',
                component: Dashboard,
                name: 'Dashboard',
                meta: {
                    title: '首页',
                    icon: 'icon-dashboard',
                    affix: true
                }
            }
        ]
    },
    {
        path: '/profile',
        component: Layout,
        redirect: '/profile/index',
        meta: { hidden: true },
        children: [
            {
                path: 'index',
                component: Profile,
                name: 'Profile',
                meta: {
                    title: '个人信息',
                    icon: 'icon-user',
                    noCache: true
                }
            }
        ]
    },
    {
        path: '/bug',
        component: Layout,
        redirect: '/bug/list',
        children: [
            {
                path: 'list',
                component: BugList,
                name: 'BugList',
                meta: {
                    title: '赏金猎人',
                    icon: 'icon-bug'
                }
            }
        ]
    },
    OnlineRoutes,
    ReportRoutes,
    PreviewRoutes,
    ReporterRoutes,
    MediaRoutes,
    NewsRoutes,
    ClueRoutes,
    ReleaseRoutes,
    EnterpriseRoutes,
    PersonRoutes,
    WinpressRoutes,
    EventRoutes,
    SettingRoutes,
    ContentRoutes,
    OthersRoutes,
    SecurityRoutes,
    LogRoutes,
    UtilsRoutes,
    {
        path: '*',
        redirect: '/'
    }
]

// 用户给外部人员查看（网络与信息安全)
export const securityConstantRoutes: RouteConfig[] = [
    {
        path: '/login',
        component: Login,
        meta: {
            title: '登录',
            hidden: true
        }
    },
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        children: [
            {
                path: 'dashboard',
                component: Dashboard,
                name: 'Dashboard',
                meta: {
                    title: '首页',
                    icon: 'icon-dashboard',
                    affix: true
                }
            }
        ]
    },
    SecurityRoutes,
    {
        path: '*',
        redirect: '/'
    }
]

const createRouter = () =>
    new Router({
        mode: 'history',
        base: process.env.BASE_URL,
        routes: constantRoutes
    })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    ;(router as any).matcher = (newRouter as any).matcher // reset router
}

export default router
